function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "linkedin",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.75,2 C21.4403559,2 22,2.55964406 22,3.25 L22,20.75 C22,21.4403559 21.4403559,22 20.75,22 L3.25,22 C2.55964406,22 2,21.4403559 2,20.75 L2,3.25 C2,2.55964406 2.55964406,2 3.25,2 L20.75,2 Z M8.66666667,8.66666667 L6.16666667,8.66666667 L6.16666667,17.8333333 L8.66666667,17.8333333 L8.66666667,8.66666667 Z M12.8333333,8.66666667 L10.3333333,8.66666667 L10.3333333,17.8333333 L12.8333333,17.8333333 L12.8333333,13.1633333 C12.8333333,10.5691667 16.1666667,10.3566667 16.1666667,13.1633333 L16.1666667,13.1633333 L16.1666667,17.8333333 L18.6666667,17.8333333 L18.6666667,12.2008333 C18.6666667,7.82333333 13.9966667,7.9825 12.8333333,10.1375 L12.8333333,10.1375 L12.8333333,8.66666667 Z M7.41666667,4.67 C6.61166667,4.67 5.95833333,5.32833333 5.95833333,6.14 C5.95833333,6.95166667 6.61166667,7.61 7.41666667,7.61 C8.2225,7.61 8.875,6.95166667 8.875,6.14 C8.875,5.32833333 8.22166667,4.67 7.41666667,4.67 Z",
  id: "Color",
  fill: "#2867B2"
}));

function SvgIcLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    className: "linkedin",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_linkedin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLinkedin);
export default __webpack_public_path__ + "static/media/ic_linkedin.6755c6f5.svg";
export { ForwardRef as ReactComponent };